module.exports = __webpack_public_path__ + "static/img/index_left_top_img.620ad54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_left_top_img.jpg
// module id = uP7B
// module chunks = 0